/**
 * 竞价品维护
 */
import React, { Component } from 'react';
import { Modal, Form, Input, InputNumber, Switch, Select } from 'antd';

import DictSelect from '../../ui/DictSelect';
import Image from '../../ui/Image';

const fields = [{
    "text": "竞价车辆",
    "field": "vehicleIds",
    "vehicle": true,
    rules: [
        { required: true, message: '竞价车辆不能为空!' },
    ]
}, {
    "text": "竞价品名称",
    "field": "name",
    rules: [
        { required: true, message: '竞价品名称不能为空!' },
        { max: 64, message: '描述信息不能超过64个字符！' },
    ]
}, {
    "text": "竞价品编号",
    "field": "code",
    "disabled": true
}, {
    "text": "起始价",
    "field": "startPrice",
    "number": true,
    rules: [
        { required: true, message: '起始价不能为空!' },
    ]
}, {
    "text": "保留价",
    "field": "reservePrice",
    "number": true,
    "disabled": true
}, {
    "text": "保证金",
    "field": "bond",
    "number": true,
    "disabled": true
}, {
    "text": "展示出价人",
    "field": "showBidder",
    "radio": true,
    "disabled": true
}, {
    "text": "服务费",
    "field": "serviceChargeDict",
    "select": true,
    category: 'AUCTION_SERVICE_CHARGE',
    "disabled": true
}, {
    "text": "加价幅度",
    "field": "offerDict",
    "select": true,
    category: 'AUCTION_OFFER_RANGE',
    rules: [
        { required: true, message: '加价幅度不能为空!' },
    ]
}, {
    "text": "顺序",
    "field": "sequence",
    "number": true,
    rules: [
        { required: true, message: '顺序不能为空!' },
    ]
}];


class AuctionLotsEditForm extends Component {

    state = {
        serviceChargeDictMap: null,
        offerDictMap: null,

        imageUrl: null,
        image: null,
    }

    componentDidMount() {
        this.props.onRef(this);
    }

    initData = (editData) => {
        let image = editData.vehicleImageThumbnail;
        if (image != null && image !== "") {
            if(image.indexOf("data:image") !== -1){

            }else{
                image = "data:image/jpeg;base64," + image.replace(/\r\n/g, "");
            }
        }
        this.setState({ image: image, imageUrl: editData.vehicleImageUrl });
    }

    handleUploadImage = (field, { base64 }) => {
        this.setState({ "image": base64, "imageUrl": null });
    }
    handleRemoveImage = (field, index) => {
        this.setState({ "image": null, "imageUrl": null });
    }

    save = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            let id = this.props.editData.id
            if (id !== undefined && id != null) {
                values["id"] = id;
            }

            let imageUrl = this.state.imageUrl;
            if (imageUrl != null && imageUrl !== "") {
                values["image"] = imageUrl;
            } else {
                values["image"] = this.state.image;
            }
            values["vehicleImageUrl"] = this.state.imageUrl;
            values["vehicleImageThumbnail"] = this.state.image;

            let keys = ["serviceChargeDict", "offerDict", "vehicleIds"];
            keys.forEach(key => {
                let dict = values[key];
                if (dict != null && dict.length > 0) {
                    let dictMap;
                    if (key === "vehicleIds") {
                        dictMap = this.props.vehicleMap;
                    } else {
                        dictMap = this.state[key + "Map"];
                        if (dictMap == null) {
                            let dictList = this[key].state.dictList;
                            dictMap = {};
                            dictList.forEach((item, index) => {
                                dictMap[item.code] = item.name;
                            });
                            this.setState({ [key + "Map"]: dictMap });
                        }
                    }
                    let array = [];
                    dict.forEach((item, index) => {
                        array.push(dictMap[item]);
                    })
                    values[key + "Str"] = array.join(",");
                    values[key] = values[key].join(",");
                }
            });

            values["showBidder"] = values["showBidder"] ? 1 : 0;

            this.props.successCallback(values);
            this.props.onCancel();
        });
    };

    vehicleSelect = (value, option) => {
        if (value != null && value.length === 1) {
            this.props.form.setFieldsValue({ "name": this.props.vehicleMap[value[0]] });
        }
    }

    createDom = (data) => {
        const { form, editData } = this.props;
        const { getFieldDecorator } = form;
        let dom = [];
        for (let i = 0; i < data.length; i++) {
            let item = data[i];
            let val = editData[item.field];
            if (item.select || item.vehicle) {
                val = editData[item.field] != null && editData[item.field].length > 0 ? editData[item.field].split(",") : undefined;
            } else if (item.radio) {
                val = editData[item.field] === 1;
            }
            let itemDom = (
                <Form.Item key={i} label={item.text + "："}>
                    {getFieldDecorator(item.field, {
                        rules: item.rules,
                        initialValue: val,
                        valuePropName: item.radio ? 'checked' : 'value'
                    })(
                        item.select ? <DictSelect onRef={(ref) => { this[item.field] = ref }} category={item.category} mode="multiple" disabled={item.disabled === true} />
                            : item.vehicle ? <Select mode="multiple" onChange={this.vehicleSelect}>
                                {this.props.vehicleList.map((item, index) => {
                                    return <Select.Option key={item.id + ""}>{item.vehicleName + "[" + item.vin + "]"}</Select.Option>
                                })}
                            </Select>
                                : item.radio ? <Switch checkedChildren="是" unCheckedChildren="否" disabled={item.disabled === true}/>
                                    : item.number ? <InputNumber precision={0} min={0} max={999999999} style={{ width: '100%' }} disabled={item.disabled === true} />
                                        : item.textarea ? <Input.TextArea />
                                            : <Input disabled={item.disabled === true} />
                    )
                    }
                </Form.Item>
            );
            dom.push(itemDom);
        }
        return dom;
    };

    render() {
        const { visible, onCancel } = this.props;
        return (
            <Modal
                width={700}
                visible={visible}
                title="竞价品编辑"
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                afterClose={() => { this.setState({ image: null, imageUrl: null, lotsList: [] }); this.props.form.resetFields() }}
            >
                <Form layout="vertical" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                    {this.createDom(fields)}
                    <Form.Item label={"批量车展示图片："}>
                        <Image
                            onChange={this.handleUploadImage.bind(this, "image")}
                            onRemove={this.handleRemoveImage.bind(this, "image")}
                            file={this.state.image}
                            text={"图片"}
                            url={this.state.imageUrl}
                        />
                    </Form.Item>
                </Form>
            </Modal>
        );
    }
}

const AuctionLotsEdit = Form.create()(AuctionLotsEditForm);

export default AuctionLotsEdit;